import {Unity,  useUnityContext } from "react-unity-webgl";
import { useEffect, useState, useRef, forwardRef, useImperativeHandle, useCallback } from "react";

const UnityGame = forwardRef((props, ref) =>{
    const {unityProvider, sendMessage, loadingProgression, isLoaded} = new useUnityContext({
      loaderUrl: "web_out_new/Build/web_out_new.loader.js",
      dataUrl: "web_out_new/Build/web_out_new.data",
      frameworkUrl: "web_out_new/Build/web_out_new.framework.js",
      codeUrl: "web_out_new/Build/web_out_new.wasm",
    });
    useImperativeHandle(ref, ()=>({
      login(nftAddress, walletAddress) {
        console.log("call login!", nftAddress);
        // TODO LOGIN logic
        console.log("msge", sendMessage("Bunny", "Login", nftAddress));
      }
    }))
    const [devicePixelRatio, setDevicePixelRatio] = useState(
      window.devicePixelRatio
    );
    const handleChangePixelRatio = useCallback(
      function () {
        // A function which will update the device pixel ratio of the Unity
        // Application to match the device pixel ratio of the browser.
        const updateDevicePixelRatio = function () {
          setDevicePixelRatio(window.devicePixelRatio);
        };
        // A media matcher which watches for changes in the device pixel ratio.
        const mediaMatcher = window.matchMedia(
          `screen and (resolution: ${devicePixelRatio}dppx)`
        );
        // Adding an event listener to the media matcher which will update the
        // device pixel ratio of the Unity Application when the device pixel
        // ratio changes.
        mediaMatcher.addEventListener("change", updateDevicePixelRatio);
        return function () {
          // Removing the event listener when the component unmounts.
          mediaMatcher.removeEventListener("change", updateDevicePixelRatio);
        };
      },
      [devicePixelRatio]
    );

    // useEffect(() => {
    //   unityProvider.on("progress", (progression) => {
    //     setProgression(progression);
    //     if (progression === 1) {
    //       setTimeout(() => {
    //         if (loading.current != null) {
    //           loading.current.style.display = "none";
    //           // Do something after
    //           console.log("after delay");
    //         }
    //       }, 3000);
    //     }
    //   });
    // }, []);
    return (
      <div style={{margintop:"80px"}}>
        {isLoaded? null:  <div
          id="loading"
          // ref={loading}
          style={{
            position: "fixed",
            zIndex: "100",
            background: "#2b2257",
            fontSize: "5rem",
            height: "400vh",
            width: "100vw",
            textAlign: "center",
            paddingTop: "40vh",
          }}
        >
          LOADING {(loadingProgression * 100).toFixed(2)} %
        </div>}
     
        <Unity
          unityProvider={unityProvider}
          style={{
            marginTop: "60px",
            height: "calc(100vh - 60px)",
            width: "100vw",
            position: "fixed",
            zIndex: "-10",
          }}
          devicePixelRatio={devicePixelRatio}
        />
      </div>
    );
  })

export default UnityGame;